import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export function sendCopyWishlist({ wishlistId }: { wishlistId: string }) {
  const url = occUrl(`/copyWishlistManual?wishlistId=${wishlistId}`);

  return occFetch(url, { method: "POST" });
}
